import React, { useEffect, useState } from "react";

import './OtpHoc.scss'

const OtpHoc = ({ length, onChange, resendOtp }) => {
	const [otp, setOtp] = useState(new Array(length).fill(""));
	const [seconds, setSeconds] = useState(30);
	const [isDisabled, setIsDisabled] = useState(true);

	useEffect(() => {
		if (seconds > 0) {
			const timer = setInterval(() => {
				setSeconds((prevSeconds) => prevSeconds - 1);
			}, 1000);

			return () => clearInterval(timer); // Cleanup timer
		} else {
			setIsDisabled(false); // Enable button when timer ends
		}
	}, [seconds]);

	const handleChange = (value, index) => {
		if (Number(value) || value === "0") {
			const newOtp = [...otp];
			newOtp[index] = value.substring(0, 1); // Only accept a single character
			// if(value.length > 1 && index+1 < length - 1){
			// 	newOtp[index+1] = value.substring(1, 2); 
			// }
			setOtp(newOtp);

			// Auto-focus to the next input field
			if (value && index < length - 1) {
				const nextInput = document.getElementById(`otp-input-${index + 1}`);
				if (nextInput) nextInput.focus();
			} 

			onChange(newOtp.join(""));
		}
	};

	const handleKeyDown = (e, index) => {
		if ( e.key === "Backspace" ) {
			const newOtp = [...otp];
			newOtp[index] = "" // Only accept a back space to remove element
			setOtp(newOtp);
			onChange(newOtp.join(""));

			if ( newOtp[index] == "" ) {
				const prevInput = document.getElementById(`otp-input-${index - 1}`);
				if (prevInput) prevInput.focus();
			}
		} else if ( e.key === 'ArrowLeft' ) {
			const prevInput = document.getElementById(`otp-input-${index - 1}`);
			if (prevInput) prevInput.focus();
		} else if ( e.key === 'ArrowRight' ) {
			const prevInput = document.getElementById(`otp-input-${index + 1}`);
			if (prevInput) prevInput.focus();
		} else{
			// console.log(e,"Sdkjhakjsdhkj")
		}
	};
	const handleResend = () => {
		setSeconds(30);
		setIsDisabled(true);
		resendOtp()
	};

	return (
		<div>
			<div className="d-flex gap-1">
				{otp.map((_, index) => (
					<input className="otp-input"
						key={index}
						id={`otp-input-${index}`}
						type="text"
						value={otp[index]}
						onChange={(e) => handleChange(e.target.value, index)}
						onKeyDown={(e) => handleKeyDown(e, index)}
						onPaste={(e)=>{
							let arr = Array.from(e.clipboardData.getData("text"))
							if(arr.length == 6) {
								arr = arr.map((t,i)=>{
									if (Number(t) || t === "0") {
										return(t)
									} else{
										return("")
									}
								})
							} else {
								arr = [...otp]
								arr[index] = ""
							}	
							onChange(arr.join(""));
							setOtp(arr)


						}}
						maxLength="2"
					/>
				))}
			</div>
			<div className="justify-content-end  d-flex my-2">
				<button className="text-link bg-transparent border-0" disabled={isDisabled} onClick={handleResend} >{isDisabled ? `Resend OTP in 00:${seconds}` : "Resend"}</button>
			</div>
		</div>
	);
};

export default OtpHoc;
